import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { MatTable } from '@angular/material/table';

@Component({
  selector: 'bdr-table-installations-control-expedientes',
  templateUrl: './bdr-table-installations-control-expedientes.component.html',
  styleUrls: ['./bdr-table-installations-control-expedientes.component.scss'],
})
export class TableInstallationsControlExpedientesComponent implements OnChanges {
  @ViewChild(MatTable, { read: ElementRef, static: false }) private matTableRef!: ElementRef;
  @Input() columns: any[] = [];
  @Input() controlExpedientes: any[] = [];
  @Input() masterOptions: any[] = [];
  @Input() workCode: string | null = null;
  @Input() canEdit = false;

  headerColumns: any[] = [];
  displayedColumns: string[] = [];
  motivosByAccion: Map<string, { cod_motivo: string; motivo: string; label: string }[]> = new Map();
  acciones: string[] = [];
  private codByAccion = new Map<string, string>();
  private masterByAccionMotivo = new Map<string, any>();

  @Output() onChangeControlExpediente = new EventEmitter<any>();

  ngOnChanges() {
    if (this.columns.length > 0) {
      this.setHeaders(this.columns);
    }
    if (this.masterOptions && this.masterOptions.length > 0) {
      this.buildMotivosByAccion();
    }
  }

  private buildMotivosByAccion(): void {
    const map = new Map<string, { cod_motivo: string; motivo: string; label: string }[]>();
    const accionesSet = new Set<string>();
    this.codByAccion = new Map();
    this.masterByAccionMotivo = new Map();
    for (const o of [...this.masterOptions].sort((a, b) => this.compareCodes(a.cod_motivo, b.cod_motivo))) {
      if (!o.accion || !o.motivo) { continue; }
      const key = `${o.accion}|${o.motivo}`;
      accionesSet.add(o.accion);
      if (!this.codByAccion.has(o.accion)) { this.codByAccion.set(o.accion, o.cod_accion); }
      if (!this.masterByAccionMotivo.has(key)) {
        this.masterByAccionMotivo.set(key, o);
        if (!map.has(o.accion)) { map.set(o.accion, []); }
        map.get(o.accion)!.push({ cod_motivo: o.cod_motivo, motivo: o.motivo, label: `${o.cod_motivo} ${o.motivo}` });
      }
    }
    this.motivosByAccion = map;
    this.acciones = Array.from(accionesSet);
  }

  setHeaders(headers: any[]) {
    this.headerColumns = headers;
    this.displayedColumns = this.headerColumns
      .filter((header: any) => header.visible)
      .map((header: any) => header.name);
  }

  private compareCodes(left: string, right: string): number {
    const leftParts = String(left || '').split('.').map((part) => Number(part));
    const rightParts = String(right || '').split('.').map((part) => Number(part));
    const maxLength = Math.max(leftParts.length, rightParts.length);

    for (let index = 0; index < maxLength; index++) {
      const leftValue = Number.isFinite(leftParts[index]) ? leftParts[index] : -1;
      const rightValue = Number.isFinite(rightParts[index]) ? rightParts[index] : -1;

      if (leftValue !== rightValue) {
        return leftValue - rightValue;
      }
    }

    return 0;
  }

  getMotivoOptions(row: any): { cod_motivo: string; motivo: string; label: string }[] {
    if (!row.accion) { return []; }
    return this.motivosByAccion.get(row.accion) || [];
  }

  private getActionCode(action: string): string | null {
    return this.codByAccion.get(action) ?? null;
  }

  onAccionChange(value: string, row: any) {
    row.accion = value;
    row.cod_accion = value ? this.getActionCode(value) : null;
    row.cod_motivo = null;
    row.motivo = null;
    row.calidad_retributiva = null;
    this.emitChange(row, {
      cod_accion: row.cod_accion,
      accion: value,
      cod_motivo: null,
      motivo: null,
      calidad_retributiva: null,
    });
  }

  onMotivoChange(value: string, row: any) {
    row.motivo = value;
    const match = this.masterByAccionMotivo.get(`${row.accion}|${value}`);
    row.cod_accion = match ? match.cod_accion : row.cod_accion;
    row.cod_motivo = match ? match.cod_motivo : null;
    const calidad = match ? match.calidad_retributiva : null;
    row.calidad_retributiva = calidad;
    this.emitChange(row, {
      cod_accion: row.cod_accion,
      cod_motivo: row.cod_motivo,
      motivo: value,
      calidad_retributiva: calidad,
    });
  }

  onComentariosChange(value: string, row: any) {
    row.comentarios = value;
    this.emitChange(row, { comentarios: value });
  }

  private emitChange(row: any, newValues: any) {
    this.onChangeControlExpediente.emit({
      anio_informacion: row.anio_informacion,
      expediente: row.expediente,
      newValues
    });
  }
}
